import { useResource } from '@landsbankinn/l16n';
import { Dropdown, useInputValidation } from '@landsbankinn/ui';
import React from 'react';
import type { appointmentServicesAndBranches_consultationServices } from '../../../../graphql/Appointment/__generated__/appointmentServicesAndBranches';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';
import type { IDropdown } from './AppointmentSelectAccess';
import res from './SelectService.res';

interface IProps {
  services: appointmentServicesAndBranches_consultationServices[];
}

export function AppointmentSelectService({ services }: IProps) {
  const { r } = useResource();
  const { state, dispatch } = useAppointmentContext();

  const [ref, isValid] = useInputValidation(state?.service?.id, [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  const options = services?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const onServiceChange = (val?: IDropdown | null) => {
    const service = services.find((s) => s.id === val?.value);
    dispatch?.({ type: 'selectService', service });
  };

  return (
    <>
      <Dropdown
        // ref={ref}
        variant="noBorder"
        labelVariant="aboveInput"
        errorMessageVariant="insideInput"
        isValid={isValid}
        buildOption={(val) => val}
        options={options}
        onChange={onServiceChange}
        value={
          state.service
            ? {
                label: state.service.name,
                value: state.service.id,
              }
            : undefined
        }
        label={r(res.pickService)}
      />
    </>
  );
}
